// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HeroSection from "../organisms/home/HeroSection.re.mjs";
import * as HomeReviews from "../organisms/home/HomeReviews.re.mjs";
import * as Core from "@linaria/core";
import * as FeaturesSection from "../organisms/home/FeaturesSection.re.mjs";
import * as ShowcaseCarousel from "../organisms/home/ShowcaseCarousel.re.mjs";
import * as NewsletterSection from "../organisms/home/NewsletterSection.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as HomeAmericanOrders from "../organisms/home/HomeAmericanOrders.re.mjs";
import * as HomeFeaturedArtists from "../organisms/home/HomeFeaturedArtists.re.mjs";
import * as HomeFeaturedProducts from "../organisms/home/HomeFeaturedProducts.re.mjs";

import { css, cx } from '@linaria/core'
;

function HomeTemplate(props) {
  let query = props.query;
  return JsxRuntime.jsxs("main", {
    children: [
      JsxRuntime.jsx(HeroSection.make, {}),
      JsxRuntime.jsx(HomeFeaturedProducts.make, {
        query: query
      }),
      JsxRuntime.jsx(ShowcaseCarousel.make, {}),
      JsxRuntime.jsx(HomeAmericanOrders.make, {
        query: query
      }),
      JsxRuntime.jsx(HomeFeaturedArtists.make, {
        query: query
      }),
      JsxRuntime.jsx(FeaturesSection.make, {}),
      JsxRuntime.jsx(HomeReviews.make, {
        query: query
      }),
      JsxRuntime.jsx(NewsletterSection.make, {})
    ],
    className: Core.cx("w-full")
  });
}

let make = HomeTemplate;

export {
  make,
}
/*  Not a pure module */
